var app = angular.module("leonardo");

var PortfolioDeleteDialog = function($scope, $rootScope, FormErrorsService, PortfolioService) {
  $scope.portfolio = $scope.ngDialogData.portfolio;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.portfolio.remove().then(function() {
      PortfolioService.updateCollection($scope.portfolio, true);
      $rootScope.$broadcast('portfolio:deleted', $scope.portfolio);
      $scope.closeThisDialog();
    });
  };
};

app.controller('PortfolioDeleteDialog', ['$scope', '$rootScope', 'FormErrorsService', 'PortfolioService',
  PortfolioDeleteDialog]);
